// extracted by mini-css-extract-plugin
module.exports = {"root":"_8ff976","avatars":"_14d359","text":"_0f83f2"};